module.exports = __webpack_public_path__ + "img/employer_benefit_empowerment_mobile.29cd24c8.jpg";